export default __webpack_public_path__ + "static/media/GarbageDelteActive.8d211dff.svg";